export default __webpack_public_path__ + "static/CurbsideManagement-5463757a158e3d625428eb2070cb5196.jpg";